import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { IoMailOutline } from "react-icons/io5";
import { LuPhone } from "react-icons/lu";
import { SlClock as SlClockIcon } from "react-icons/sl"; 
import { CiLocationOn } from "react-icons/ci";
import './ContactPage.css'

import EstimateForm from '../ContactPage/EstimateForm/EstimateForm';
import Areas from '../ContactPage/AreasWeServeAround/Areas'; 
import { Helmet } from 'react-helmet';

function ContactPage() {
    const [visible, setVisible] = useState(false);

    // Scroll to top and set visibility
    useEffect(() => {
        window.scrollTo(0, 0);
        setVisible(true);
    }, []);

    return (
        <div className='contact-page'>

            {/* Helmet component for SEO meta tags */}
            <Helmet>
                <title>Ultimates Roofing LLC - Contact Us</title>
                <link rel="canonical" href="https://www.ultimatesroofing.com/contact" />
                <meta name='description' content='Get in touch with Ultimates Roofing LLC for all your construction and home improvement needs. Whether you have questions, need a quote, or want to discuss a project, our team is here to assist you.' />
                <meta name='keywords' content='Ultimates Roofing llc, Ultimates Roofing, Best Roofing design in columbus,ohio, Best Roofing Companies in columbus ohio, ultimates roof replacement near me, best roofing designs for small houses, best roofing drip edge, best roof columbus, best roofing company near me, ultimates roof replacement columbus ohio, best roofing company, ultimates roof repair columbus ohio, affordable roof, eplacement services in columbus,ohio, luxury home roofing solutions near me, roof repair, Roofer near me, roofing repairs near me, roofing sheet' />
                <meta name='author' content='Ultimates Roofing LLC' />
                <meta name='robots' content='index, follow' />
                <html lang="en" />
            </Helmet>

            {/* Contact Information Section */}
            <div className='contact-us'>
                <h2 className='contact-heading mb-3 mb-md-4'>Contact Us</h2>

                {/* contact boxes */}
                <Row style={{ margin: "1px auto" }} className='contact-sections-row mt-1'>
                    <Col>
                        <div className={`contact-sections ${visible ? 'fade-in visible' : 'fade-in'}`}>
                            <div className='contact-text'>
                                <p style={{ fontWeight: "bold", fontSize: "23px" }}><LuPhone className='contact-icon' /> Call Us</p>
                                <p className='address-text'>614-357-7539</p>
                            </div>
                        </div>
                    </Col>

                    <Col>
                        <div className={`contact-sections ${visible ? 'fade-in visible' : 'fade-in'}`}>
                            <div className='contact-text'>
                                <p style={{ fontWeight: "bold", fontSize: "23px" }}><IoMailOutline className='contact-icon' /> E-mail</p>
                                <p className='address-text'>roofs@ultimatesroofing.com</p>
                            </div>
                        </div>
                    </Col>
                    
                    <Col>
                        <div className={`contact-sections ${visible ? 'fade-in visible' : 'fade-in'}`}>
                            <div className='contact-text'>
                                <p style={{ fontWeight: "bold", fontSize: "23px" }}><SlClockIcon className='contact-icon' /> Timings</p>
                                <p className='address-text'>Monday - Friday</p>
                                <p className='address-text'>9 AM - 5 PM</p>
                            </div>
                        </div>
                    </Col>
                    
                    <Col>
                        <div className={`contact-sections ${visible ? 'fade-in visible' : 'fade-in'}`}>
                            <div className='contact-text'>
                                <p style={{ fontWeight: "bold", fontSize: "23px" }}><CiLocationOn className='contact-icon' /> Address</p>
                                <p className='address-text'>2756 Sawbury Blvd</p>
                                <p className='address-text'>Columbus, Ohio 43235, USA</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* Contact Form Section */}
            <EstimateForm />

            <Areas />
        </div>
    )
}

export default ContactPage;